"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CodeInput = _interopRequireDefault(require("../../../components/Input/CodeInput"));
var _reactI18next = require("react-i18next");
var _Text = require("../Text");
var _useDebounce = require("use-debounce");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SEND_PERIOD = 60;
var Timing = function Timing(_ref) {
  var onTime = _ref.onTime,
    period = _ref.period;
  var _useState = (0, _react.useState)(period - 1),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  var timeRef = (0, _react.useRef)(time);
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      setTime(function (time) {
        timeRef.current = time - 1;
        return time - 1;
      });
      if (timeRef.current < 0) {
        onTime();
      }
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary font-semibold inline-block"
  }, time);
};
var initialState = {
  loading: false,
  resent: false,
  resentError: false
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'sending':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: true
        });
      }
    case 'sendSuccess':
      {
        return {
          loading: false,
          resent: true,
          resentError: false
        };
      }
    case 'sendFailure':
      {
        return {
          loading: false,
          resent: false,
          resentError: true
        };
      }
    case 'initial':
      {
        return {
          loading: false,
          resent: false,
          resentError: false
        };
      }
    default:
      throw Error('Unknow action type');
  }
};
var ResendButton = function ResendButton(_ref2) {
  var onClick = _ref2.onClick,
    login = _ref2.login,
    disabled = _ref2.disabled;
  var _useReducer = (0, _react.useReducer)(reducer, initialState),
    _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var resentError = state.resentError,
    resent = state.resent,
    loading = state.loading;
  var _useDebouncedCallback = (0, _useDebounce.useDebouncedCallback)(function () {
      dispatch({
        type: 'sending'
      });
      onClick().then(function () {
        return dispatch({
          type: 'sendSuccess'
        });
      })["catch"](function (e) {
        return dispatch({
          type: 'sendFailure'
        });
      });
    }, 1000, {
      leading: true
    }),
    _useDebouncedCallback2 = (0, _slicedToArray2["default"])(_useDebouncedCallback, 1),
    handleResentCode = _useDebouncedCallback2[0];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-secondary', {
      'mt-12': !login,
      'text-xs': !login,
      'text-sm': login
    })
  }, resent ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold"
  }, "You can resend your code in\xA0", /*#__PURE__*/_react["default"].createElement(Timing, {
    period: SEND_PERIOD,
    onTime: function onTime() {
      return dispatch({
        type: 'initial'
      });
    }
  }), "\xA0s") : resentError ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold"
  }, "Resent code error, you can\xA0", /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-primary font-semibold",
    onClick: handleResentCode,
    disabled: loading || disabled
  }, "retry")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Didn't get a code?\xA0", /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleResentCode,
    disabled: loading || disabled,
    className: "text-primary font-semibold"
  }, "Resend code")));
};
function EnterCodeStep(_ref3, ref) {
  var onVerify = _ref3.onVerify,
    onSendCode = _ref3.onSendCode,
    onNext = _ref3.onNext,
    phoneNumber = _ref3.phoneNumber,
    _ref3$login = _ref3.login,
    login = _ref3$login === void 0 ? false : _ref3$login;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    loaded = _useState8[0],
    setLoaded = _useState8[1];
  var handleOnChange = function handleOnChange(next) {
    setValue(next.replace(/[^0-9]/gi, ''));
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      next: function next() {
        if (value.trim().length < 6) {
          setError(true);
          return Promise.reject('empty code');
        }
        return onVerify(value).then(function (res) {
          setLoaded(true);
          return res;
        })["catch"](function (e) {
          setError(true);
          throw e;
        });
      }
    };
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Text.PrimaryText, {
    className: login ? 'text-3xl' : ''
  }, t('twoFactorAuthentication.enterCodeStep.primaryTitle')), /*#__PURE__*/_react["default"].createElement(_Text.PhoneNumberText, {
    className: login ? 'text-3xl' : ''
  }, phoneNumber), login && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-md py-2"
  }, t('twoFactorAuthentication.finishStep.secondaryTitle')), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "code",
    className: "text-gray-light text-sm font-semibold my-2 block"
  }, t('twoFactorAuthentication.enterCodeStep.codeLabel')), /*#__PURE__*/_react["default"].createElement(_CodeInput["default"], {
    id: "code",
    autoFocus: true,
    standalone: true,
    value: value,
    onChange: handleOnChange,
    onKeyDown: function onKeyDown(e) {
      e.key === 'Enter' && onNext();
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex justify-between mt-1', {
      absolute: !login
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-red text-sm "
  }, error && t('twoFactorAuthentication.enterCodeStep.error')), login && /*#__PURE__*/_react["default"].createElement(ResendButton, {
    login: true,
    onClick: onSendCode,
    disabled: loaded
  }))), !login && /*#__PURE__*/_react["default"].createElement(ResendButton, {
    login: false,
    onClick: onSendCode,
    disabled: loaded
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(EnterCodeStep);
//# sourceMappingURL=SMSEnterCode.js.map